import React from 'react';

import { Entity } from '@backstage/catalog-model';

import { getSubscriptionTechnicalContactsFromAnnotation } from './subscriptionTechnicalContacts';

export const getSubscriptionTechnicalContactsForDisplay = (
  entity: Entity | undefined,
  technicalContactRefs: string[],
): string[] => {
  const technicalContactsFromAnnotation =
    getSubscriptionTechnicalContactsFromAnnotation(entity).map(contact =>
      contact.toLocaleLowerCase(),
    );

  if (technicalContactsFromAnnotation.length > 0) {
    return technicalContactsFromAnnotation;
  }

  return technicalContactRefs.map(ref => ref.replace(/^user:[^/]+\//, ''));
};

export const getDisabledSubscriptionOwnershipTooltip = (options: {
  technicalContactsDisplay: string[];
  includeContactSetupMessage?: boolean;
}): React.ReactNode => {
  const { technicalContactsDisplay, includeContactSetupMessage = false } =
    options;

  if (technicalContactsDisplay.length > 0) {
    return (
      <>
        <div>
          This button is disabled because you are not a technical contact for
          this subscription.
        </div>
        <div style={{ marginTop: 4 }}>
          Only technical contacts can change subscription ownership.
        </div>
        <div style={{ marginTop: 6 }}>Allowed users:</div>
        <ul style={{ margin: '4px 0 0 16px', padding: 0 }}>
          {technicalContactsDisplay.map((contact, index) => (
            <li key={`${contact}-${index}`}>{contact}</li>
          ))}
        </ul>
      </>
    );
  }

  return (
    <>
      <div>
        This button is disabled because no technical contacts are configured for
        this subscription.
      </div>
      <div style={{ marginTop: 4 }}>
        Only technical contacts can change subscription ownership.
      </div>
      {includeContactSetupMessage ? (
        <div style={{ marginTop: 4 }}>
          Please contact us to set up technical contacts for this subscription.
        </div>
      ) : null}
    </>
  );
};
